import styled from 'styled-components'

const StyledPlanEndedView = styled.div``

export default StyledPlanEndedView
